// extracted by mini-css-extract-plugin
module.exports = {"box":"index_box_1jiDW","content":"index_content_270Ci"};